export default {
  'menu.introducing-broker.home': 'IB Dashboard',
  'menu.introducing-broker.commission-report': 'Commission Report',
  'menu.introducing-broker.commission-report.home': 'Commission Report',
  'menu.introducing-broker.commission-report.detail': 'Commission Detail',
  'menu.introducing-broker.commission-report.detail.home': 'Commission Detail',
  'menu.introducing-broker.flow-commission': 'Flow Commission',
  'menu.introducing-broker.flow-commission.home': 'Flow Commission',
  'menu.introducing-broker.funding-details': 'Funding Details',
  'menu.introducing-broker.funding-details.home': 'Funding Details',
  'menu.introducing-broker.funding-details.detail': 'Funding Details',
  'menu.introducing-broker.invitation-management': 'Invitation Management',
  'menu.invitation-management.home': 'Invitation Management',
  'menu.invitation-management.add': 'Invitation Management',
  'menu.introducing-broker.my-investor': 'My Investor',
  'menu.my-investor.home': 'My Investor',
  'menu.introducing-broker.performance-report': 'Performance Report',
  'menu.introducing-broker.performance-report.home': 'Performance Report',
  'menu.introducing-broker.promotion-campaign': 'Promotion Campaign',
  'menu.introducing-broker.promotion-campaign.home': 'Promotion Campaign',
  'menu.introducing-broker.promotion-campaign.detail': 'Promotion Campaign',
  'menu.introducing-broker.promotion-campaign.detail.home': 'Promotion Campaign',
  'menu.introducing-broker.rebate-settings': 'Rebate Settings',
  'menu.introducing-broker.rebate-settings.home': 'Rebate Settings',
  'menu.introducing-broker.trade-commission': 'Trade Commission',
  'menu.introducing-broker.trade-commission.home': 'Trade Commission',
  'menu.introducing-broker.agency-report': 'Agency report form',
}
